import { Component, DestroyRef, OnInit, inject, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { CompanyCardComponent } from "../../shared/components/network-card/company-card.component";
import { Company } from "../../api/models/company";
import { CompanyService } from "../../shared/services/company.service";
import { FeedService } from "../../shared/services/feed.service";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { DomainService } from "../../shared/services/domain.service";
import { catchError } from "rxjs/operators";

@Component({
  selector: "app-page-internationals",
  templateUrl: "./page-internationals.component.html",
  styleUrls: ["./page-internationals.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, CompanyCardComponent],
})
export class PageInternationalsComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  companies: Company[] = [];
  readonly isLoading = signal(false);

  constructor(
    public companyService: CompanyService,
    public feed: FeedService,
    public authService: AuthenticationService,
    private domain: DomainService
  ) {}

  ngOnInit(): void {
    this.loadCompanies();
  }

  loadCompanies(): void {
    this.isLoading.set(true);

    const params = {
      pageNumber: 1,
      pageSize: 30,
      CompanyTargetGroups: ["International"],
    };

    this.companyService
      .apiGetCompanies(params, this.domain.getCurrentRegion())
      .pipe(
        catchError(this.companyService.handleError("apiGetCompanies", false)),
        takeUntilDestroyed(this.destroyRef)
      )
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .subscribe((result: any) => {
        this.isLoading.set(false);
        if (result && result.data) {
          this.companies = result.data;
        }
      });
  }

  Register(): void {
    this.authService.setRegistrationTargetGroup("International");
    this.authService.SignUp();
  }
}
